import React from 'react';
import './CasePage.css';

const CasePage: React.FC = () => {
    return (
        <div className="case-page">
            <div className="case-page-bg">
                {/* Main Content */}
                <main className="case-main">
                    <div className="case-banner">
                        <img src="./case/case_page_title.webp" width={300}/>
                    </div>

                    {/* Case 1 */}
                    <div className="case-section">
                        <img src="./case/case_1.webp" width={"100%"}/>
                    </div>

                    {/* Case 2 */}
                    <div className="case-section">
                        <img src="./case/case_2.webp" width={"100%"}/>
                    </div>

                    {/* Case 3 */}
                    <div className="case-section">
                        <img src="./case/case_3.webp" width={"100%"}/>
                    </div>

                    {/* Case 4 */}
                    <div className="case-section">
                        <img src="./case/case_4.webp" width={"100%"}/>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default CasePage;